import React from 'react'
import { Badge } from '../common/badge/Badge'

type ClusterCountBadgeProps = {
   count: number
   onClick: () => void
}
export const ClusterCountBadge = ({ count, onClick }: ClusterCountBadgeProps) => {
   return (
      <Badge appearance="filled" color="brand" shape="circular" size="extra-large" style={{ cursor: 'pointer' }} onClick={onClick}>
         {`+${count}`}
      </Badge>
   )
}
